import { render, staticRenderFns } from "./FieldBoolean.vue?vue&type=template&id=39e8620c&scoped=true"
import script from "./FieldBoolean.vue?vue&type=script&lang=js"
export * from "./FieldBoolean.vue?vue&type=script&lang=js"
import style0 from "./FieldBoolean.vue?vue&type=style&index=0&id=39e8620c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8620c",
  null
  
)

export default component.exports